export const QA_NAME_CONFIRMATION_CLEAR_MODAL = 'clear'
